var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoomMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9697 20.5304C20.2627 20.8232 20.7375 20.8232 21.0304 20.5303C21.3232 20.2373 21.3232 19.7625 21.0303 19.4696L19.9697 20.5304ZM8.05556 10.3611C7.64134 10.3611 7.30556 10.6969 7.30556 11.1111C7.30556 11.5253 7.64134 11.8611 8.05556 11.8611V10.3611ZM15.1667 11.8611C15.5809 11.8611 15.9167 11.5253 15.9167 11.1111C15.9167 10.6969 15.5809 10.3611 15.1667 10.3611V11.8611ZM11.6111 17.4722C8.09797 17.4722 5.25 14.6243 5.25 11.1111H3.75C3.75 15.4527 7.26954 18.9722 11.6111 18.9722V17.4722ZM5.25 11.1111C5.25 7.59797 8.09797 4.75 11.6111 4.75V3.25C7.26954 3.25 3.75 6.76954 3.75 11.1111H5.25ZM11.6111 4.75C15.1243 4.75 17.9722 7.59797 17.9722 11.1111H19.4722C19.4722 6.76954 15.9527 3.25 11.6111 3.25V4.75ZM21.0303 19.4696L17.1693 15.6095L16.1087 16.6702L19.9697 20.5304L21.0303 19.4696ZM8.05556 11.8611H15.1667V10.3611H8.05556V11.8611ZM17.9722 11.1111C17.9722 12.8681 17.2609 14.4575 16.1087 15.6095L17.1693 16.6702C18.5913 15.2484 19.4722 13.2819 19.4722 11.1111H17.9722ZM16.1087 15.6095C14.9568 16.7612 13.3677 17.4722 11.6111 17.4722V18.9722C13.7814 18.9722 15.7476 18.0917 17.1693 16.6702L16.1087 15.6095Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomMinus);
export default __webpack_public_path__ + "static/media/zoom_minus.a94d22976a5d9cba6aace7bd01eaa4ab.svg";
export { ForwardRef as ReactComponent };